<template>
  <v-sheet width="100%" class="py-2 px-5 d-flex justify-space-between align-center">
    <svg width="90" viewBox="0 0 135 42" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_0_18)">
        <path
          d="M10.6707 42.7371V19.6842C10.6707 16.3 11.5076 12.9624 13.1815 10.0516C15.2701 6.44235 19.0099 2.75544 25.6451 2.42167C38.9079 1.76191 42.3386 12.7761 42.7608 14.9805C43.183 17.1848 44.6835 24.6751 39.3377 31.0632C35.4244 35.7358 29.5055 36.5819 26.6102 36.6905C25.6677 36.7294 24.8911 35.9454 24.8911 34.9829V26.9028C24.8911 26.0179 25.547 25.2728 26.4066 25.2029C28.6837 25.0089 32.6949 23.9688 32.3858 19.0632C31.956 12.2327 24.8986 13.56 23.3981 15.0969C23.27 15.2288 23.1569 15.353 23.0513 15.4695C22.1691 16.4707 21.6866 17.7903 21.6715 19.1408L21.4905 32.0179C21.483 32.7475 21.3774 33.4771 21.1739 34.1834C20.352 37.0243 17.6828 43.6918 10.6707 42.7371Z"
          fill="#277FAF"
        />
        <mask
          id="mask0_0_18"
          style="mask-type: alpha"
          maskUnits="userSpaceOnUse"
          x="10"
          y="2"
          width="34"
          height="41"
        >
          <path
            d="M10.6933 42.75V19.6971C10.6933 16.3129 11.5303 12.9753 13.2041 10.0646C15.2927 6.45527 19.0325 2.76836 25.6677 2.4346C38.9306 1.77484 42.3613 12.789 42.7835 14.9934C43.2058 17.1978 44.7062 24.688 39.3604 31.0761C35.4471 35.7488 29.5282 36.5948 26.6329 36.7035C25.6904 36.7423 24.9137 35.9583 24.9137 34.9958V26.9157C24.9137 26.0308 25.5697 25.2857 26.4293 25.2158C28.7064 25.0218 32.7176 23.9817 32.4085 19.0762C31.9787 12.2457 24.9213 13.573 23.4208 15.1098C23.2926 15.2418 23.1795 15.366 23.074 15.4824C22.1918 16.4837 21.7092 17.8032 21.6942 19.1538L21.5132 32.0308C21.5057 32.7604 21.4001 33.49 21.1965 34.1964C20.3747 37.0372 17.7055 43.7047 10.6933 42.75Z"
            fill="#277FAF"
          />
        </mask>
        <g mask="url(#mask0_0_18)">
          <g filter="url(#filter0_d_0_18)">
            <path
              d="M36.4722 5.30145C33.9312 3.46964 30.4251 2.18892 25.6447 2.42954C19.0096 2.76331 15.2697 6.45022 13.1811 10.0595C11.4997 12.9625 10.6703 16.3079 10.6703 19.692V42.7449C17.6825 43.6997 20.3592 37.0322 21.1735 34.1913C21.3771 33.485 21.4751 32.7631 21.4902 32.0257L21.6712 19.1487C21.6863 18.225 21.92 17.3169 22.3422 16.5174C22.3422 16.5097 22.3422 16.5097 22.3422 16.5019C23.0962 8.31308 36.4722 5.30145 36.4722 5.30145Z"
              fill="url(#paint0_linear_0_18)"
            />
          </g>
          <path
            d="M29.7012 2.60827C28.4647 2.42198 27.115 2.35212 25.6447 2.42198C19.0095 2.75574 15.2697 6.44266 13.1811 10.0519C11.4997 12.9549 10.6703 16.3003 10.6703 19.6845V42.7374C11.1906 42.8072 11.6807 42.8305 12.1481 42.8228C17.5166 36.5434 14.3498 29.5111 14.9455 19.6069C15.5864 9.03514 29.7012 2.60827 29.7012 2.60827Z"
            fill="url(#paint1_linear_0_18)"
          />
        </g>
      </g>
      <path
        d="M62.465 24.6617V31.2142H60.2784V14.4624H66.3874C68.2021 14.4624 69.6223 14.9296 70.6479 15.8641C71.6736 16.7985 72.1921 18.0407 72.1921 19.5791C72.1921 21.2087 71.6849 22.4623 70.6818 23.3397C69.6786 24.2172 68.2359 24.6617 66.3649 24.6617H62.465ZM62.465 22.8497H66.3874C67.5596 22.8497 68.45 22.5762 69.07 22.0178C69.6899 21.4594 70.0055 20.6503 70.0055 19.6019C70.0055 18.5991 69.6899 17.8014 69.07 17.2088C68.45 16.6048 67.5934 16.2971 66.5114 16.2743H62.465V22.8497Z"
        fill="#277FAF"
      />
      <path
        d="M80.6003 20.6727C80.2847 20.6158 79.9353 20.593 79.5633 20.593C78.177 20.593 77.2415 21.1856 76.7568 22.3707V31.2025H74.6491V18.7696H76.7005L76.7343 20.2055C77.4218 19.0887 78.4024 18.5417 79.6648 18.5417C80.0706 18.5417 80.3861 18.5987 80.6003 18.7013V20.6727Z"
        fill="#277FAF"
      />
      <path
        d="M81.7503 24.8783C81.7503 23.6589 81.987 22.5649 82.4604 21.5849C82.9338 20.6162 83.5988 19.8641 84.4441 19.3285C85.2894 18.8043 86.2588 18.5308 87.3408 18.5308C89.0202 18.5308 90.3728 19.112 91.4097 20.2858C92.4467 21.4595 92.9651 23.0208 92.9651 24.9694V25.1176C92.9651 26.3255 92.7397 27.4196 92.2776 28.3768C91.8155 29.3341 91.1618 30.0862 90.3051 30.6218C89.4485 31.1574 88.4679 31.4309 87.3633 31.4309C85.6952 31.4309 84.3427 30.8497 83.3057 29.6759C82.2688 28.5022 81.7503 26.9523 81.7503 25.015V24.8783ZM83.8693 25.129C83.8693 26.5079 84.1849 27.6133 84.8161 28.4566C85.4472 29.2885 86.2926 29.7101 87.3633 29.7101C88.4341 29.7101 89.2795 29.2885 89.9106 28.4338C90.5418 27.5905 90.8574 26.3939 90.8574 24.8783C90.8574 23.5108 90.5418 22.4054 89.8994 21.5621C89.2569 20.7188 88.4116 20.2858 87.3408 20.2858C86.3039 20.2858 85.4585 20.7074 84.8273 21.5393C84.1849 22.3826 83.8693 23.5792 83.8693 25.129Z"
        fill="#277FAF"
      />
      <path
        d="M105.08 26.8383H98.1374L96.5707 31.2142H94.3164L100.64 14.4624H102.556L108.89 31.2142H106.647L105.08 26.8383ZM98.7911 25.0263H104.427L101.609 17.186L98.7911 25.0263Z"
        fill="#277FAF"
      />
      <path
        d="M121.2 25.1285C121.2 27.0202 120.772 28.5473 119.915 29.7096C119.058 30.872 117.898 31.4418 116.432 31.4418C114.933 31.4418 113.761 30.9632 112.904 30.0059V36.0001H110.797V18.7696H112.724L112.825 20.1485C113.682 19.0773 114.877 18.5417 116.398 18.5417C117.875 18.5417 119.047 19.1001 119.904 20.2283C120.76 21.3565 121.2 22.9291 121.2 24.9348V25.1285ZM119.092 24.8892C119.092 23.4875 118.799 22.3821 118.202 21.5616C117.616 20.7525 116.793 20.3423 115.767 20.3423C114.494 20.3423 113.536 20.9121 112.904 22.0516V28.0003C113.536 29.1398 114.494 29.6982 115.79 29.6982C116.804 29.6982 117.604 29.2994 118.202 28.4789C118.799 27.6812 119.092 26.4846 119.092 24.8892Z"
        fill="#277FAF"
      />
      <path
        d="M134.273 25.1285C134.273 27.0202 133.845 28.5473 132.988 29.7096C132.132 30.872 130.971 31.4418 129.506 31.4418C128.006 31.4418 126.834 30.9632 125.978 30.0059V36.0001H123.87V18.7696H125.797L125.899 20.1485C126.755 19.0773 127.95 18.5417 129.472 18.5417C130.948 18.5417 132.12 19.1001 132.977 20.2283C133.834 21.3565 134.273 22.9291 134.273 24.9348V25.1285ZM132.166 24.8892C132.166 23.4875 131.873 22.3821 131.275 21.5616C130.689 20.7525 129.866 20.3423 128.841 20.3423C127.567 20.3423 126.609 20.9121 125.978 22.0516V28.0003C126.609 29.1398 127.567 29.6982 128.863 29.6982C129.878 29.6982 130.678 29.2994 131.275 28.4789C131.873 27.6812 132.166 26.4846 132.166 24.8892Z"
        fill="#277FAF"
      />
      <defs>
        <filter
          id="filter0_d_0_18"
          x="6.67033"
          y="-1.5995"
          width="33.8018"
          height="48.4372"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="2" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.00293403 0 0 0 0 0.0345777 0 0 0 0 0.0541667 0 0 0 0.89 0"
          />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_0_18" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_0_18" result="shape" />
        </filter>
        <linearGradient
          id="paint0_linear_0_18"
          x1="10.6669"
          y1="22.612"
          x2="36.4705"
          y2="22.612"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#277FAF" />
          <stop offset="0.3356" stop-color="#2578AD" />
          <stop offset="0.8385" stop-color="#1E63A6" />
          <stop offset="1" stop-color="#1C5BA3" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_0_18"
          x1="10.6669"
          y1="22.61"
          x2="29.6982"
          y2="22.61"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="8.24799e-08" stop-color="#1C5BA3" />
          <stop offset="0.1615" stop-color="#1E63A6" />
          <stop offset="0.6644" stop-color="#2578AD" />
          <stop offset="1" stop-color="#277FAF" />
        </linearGradient>
        <clipPath id="clip0_0_18">
          <rect width="49.5" height="42" fill="white" transform="translate(0.36335)" />
        </clipPath>
      </defs>
    </svg>

    <div class="d-flex f14">
      <svg
        width="16"
        height="17"
        viewBox="0 0 16 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        class="ml-4 mr-1"
      >
        <path
          d="M6.65074 9.39131C7.63149 10.4073 8.81817 11.1917 10.1274 11.6894L11.8987 10.2501C11.9512 10.2132 12.0135 10.1934 12.0772 10.1934C12.141 10.1934 12.2032 10.2132 12.2557 10.2501L15.5445 12.4138C15.6694 12.4905 15.7751 12.5957 15.8532 12.7212C15.9314 12.8468 15.9799 12.9891 15.995 13.1371C16.01 13.2851 15.9912 13.4346 15.9399 13.5738C15.8886 13.7131 15.8063 13.8383 15.6996 13.9395L14.1585 15.4939C13.9378 15.7166 13.6666 15.88 13.369 15.9695C13.0714 16.0591 12.7568 16.0721 12.4531 16.0072C9.42374 15.3683 6.63154 13.8721 4.39558 11.6894C2.20924 9.48499 0.696308 6.6801 0.0403042 3.61498C-0.0245005 3.30967 -0.0109749 2.99245 0.0795703 2.69406C0.170115 2.39566 0.33461 2.12621 0.557111 1.91182L2.15452 0.338198C2.25337 0.234468 2.37392 0.154917 2.50714 0.105503C2.64036 0.0560887 2.78281 0.0380915 2.92381 0.052859C3.06481 0.0676265 3.20071 0.114776 3.32134 0.190777C3.44197 0.266778 3.5442 0.369661 3.62037 0.491722L5.80975 3.80688C5.84751 3.85894 5.8679 3.92201 5.8679 3.98679C5.8679 4.05158 5.84751 4.11465 5.80975 4.1667L4.36739 5.93702C4.86802 7.24723 5.64801 8.42719 6.65074 9.39131Z"
          fill="#277FAF"
        />
      </svg>
      {{ companiesConfig.phone }}
      <svg
        width="17"
        height="17"
        viewBox="0 0 17 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        class="ml-4 mr-1"
      >
        <path
          d="M8.20599 3.36845C9.5038 3.36845 10.7267 3.93288 11.6229 4.81522V4.81782C11.6229 4.39411 11.9135 4.07359 12.3151 4.07359H12.4171C13.0508 4.07359 13.1778 4.65991 13.1778 4.84492L13.1805 11.4299C13.1364 11.8614 13.6347 12.0845 13.9114 11.8072C14.9872 10.7216 16.2765 6.22081 13.2416 3.61496C10.4111 1.18266 6.6123 1.58448 4.59255 2.94995C2.44583 4.40506 1.07366 7.61911 2.40652 10.6398C3.8621 13.9331 8.02325 14.9155 10.4999 13.9357C11.7536 13.439 12.3315 15.0995 11.0284 15.643C9.06447 16.4649 3.59117 16.381 1.03488 12.0381C-0.692159 9.10444 -0.600788 3.94382 3.98163 1.27022C7.48405 -0.776415 12.1052 -0.209382 14.891 2.64402C17.8022 5.6298 17.6338 11.2162 14.7917 13.3879C13.5045 14.3756 11.5931 13.415 11.6069 11.9761L11.5926 11.507C10.6964 12.3779 9.5038 12.8887 8.20599 12.8887C5.63855 12.8887 3.37815 10.6706 3.37815 8.15435C3.37815 5.61104 5.63855 3.36949 8.20599 3.36949V3.36845ZM11.4354 7.97246C11.3381 6.12909 9.94366 5.01899 8.25859 5.01899H8.19484C6.25265 5.01899 5.17372 6.51996 5.17372 8.22158C5.17372 10.1296 6.47683 11.3345 8.18687 11.3345C10.0956 11.3345 11.3488 9.96437 11.4401 8.34354L11.4354 7.97246Z"
          fill="#277FAF"
        />
      </svg>
      {{ companiesConfig.email }}
    </div>
  </v-sheet>
</template>

<script>
import LogoMain from 'components/icons/LogoMain'
import { mapGetters } from 'vuex'
export default {
  name: 'FooterPdf',
  computed: {
    ...mapGetters(['companiesConfig']),
  },
}
</script>
